var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-view",
    { attrs: { tag: "w-container" } },
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c(
                "w-card",
                [
                  _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("settings")))]),
                  _c(
                    "w-card-content",
                    [
                      _c("w-row", [_vm._t("options")], 2),
                      _c(
                        "w-row",
                        [
                          _c(
                            "w-col",
                            { attrs: { md: "6", xs: "12" } },
                            [
                              _c("app-custom-lang-select", {
                                attrs: { label: _vm.$ct("lang"), fancy: "" },
                                model: {
                                  value: _vm.selectedLang,
                                  callback: function ($$v) {
                                    _vm.selectedLang = $$v
                                  },
                                  expression: "selectedLang",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { md: "6", xs: "12" } },
                            [
                              _c("w-switch", {
                                attrs: { label: _vm.$ct("is-html"), right: "" },
                                model: {
                                  value: _vm.value.IsHTML,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.value, "IsHTML", $$v)
                                  },
                                  expression: "value.IsHTML",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12", md: "6" } },
                            [
                              _c("w-input", {
                                attrs: { fancy: "", label: _vm.$ct("subject") },
                                on: {
                                  mouseup: function ($event) {
                                    return _vm.onSubjectMouseUp($event)
                                  },
                                  keyup: function ($event) {
                                    return _vm.onSubjectKeyUp($event)
                                  },
                                },
                                model: {
                                  value:
                                    _vm.value.Subject.Translations[
                                      _vm.selectedLang
                                    ],
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.value.Subject.Translations,
                                      _vm.selectedLang,
                                      $$v
                                    )
                                  },
                                  expression:
                                    "value.Subject.Translations[selectedLang]",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { md: "6", xs: "12" } },
                            [
                              _c("app-mail-template-prop-select", {
                                attrs: {
                                  "is-subject": "",
                                  text:
                                    _vm.value.Subject.Translations[
                                      _vm.selectedLang
                                    ] || "",
                                  "cursor-position": _vm.subjectCursorPosition,
                                  data: _vm.subjectData,
                                },
                                on: {
                                  add: function ($event) {
                                    return _vm.addSubjectProp($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "w-col",
                            { attrs: { xs: "12" } },
                            [
                              _c("app-mail-template-prop-select", {
                                attrs: {
                                  text: _vm.contentAsText,
                                  "cursor-position": _vm.cursorPosition,
                                  data: _vm.contentData,
                                },
                                on: {
                                  add: function ($event) {
                                    return _vm.addProp($event)
                                  },
                                  "add-link": _vm.addLink,
                                  "add-image": function ($event) {
                                    return _vm.addImage($event)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("w-row", [_vm._t("extra-options")], 2),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("app-mail-template-editor", {
                ref: "editor",
                attrs: { "is-html": _vm.value.IsHTML, value: _vm.selectedText },
                on: {
                  input: function ($event) {
                    return _vm.onContentUpdate($event)
                  },
                  "text-value": function ($event) {
                    _vm.contentAsText = $event
                  },
                  "cursor-position-change": function ($event) {
                    _vm.cursorPosition = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }